import React, { useEffect, useState } from "react";

const DebouncedButton = ({ delay=500, onClick=undefined, ...props }) => {
    const [isDisabled, setDisabled] = useState(false);
  

    useEffect(() => {
      if (!isDisabled) {
        // timeout elapsed, nothing to do
        return;
      }
  
      // isDisabled was changed to true, set back to false after `delay`
      const handle = setTimeout(() => {
        setDisabled(false);
      }, delay);
      return () => clearTimeout(handle);
    }, [isDisabled, delay]);
  
    const handleClick = (e) => {
      if (isDisabled) {
        return;
      }
  
      setDisabled(true);
      if( onClick) onClick(e);

      return true;
    };
  
    return  <button {...props} 
      disabled={isDisabled} 
      onClick={handleClick}>{
        props.children}
      </button>
      ;
  };

  export default DebouncedButton;